import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import SchoolIcon from '@mui/icons-material/School';
import HomeIcon from '@mui/icons-material/Home';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import VerifiedIcon from '@mui/icons-material/Verified';

const LOAN_CONFIG = {
  'Education Loan':          { accent: '#D32028', bg: '#fff0f0', Icon: SchoolIcon },
  'Consumer Loan':           { accent: '#7c3aed', bg: '#f5f3ff', Icon: ShoppingBagIcon },
  'Mortgage Loan':           { accent: '#d97706', bg: '#fffbeb', Icon: HomeIcon },
  'Business Loan':           { accent: '#16a34a', bg: '#f0fdf4', Icon: BusinessCenterIcon },
  'Personal Loan':           { accent: '#2563eb', bg: '#eff6ff', Icon: AccountBalanceWalletIcon },
  'Vehicle Loan':            { accent: '#ec4899', bg: '#fdf2f8', Icon: DirectionsCarIcon },
  'Term Loan':               { accent: '#f97316', bg: '#fff7ed', Icon: CalendarMonthIcon },
  'Loan Against Securities': { accent: '#0d9488', bg: '#f0fdfa', Icon: ShowChartIcon },
  'Eligibility':             { accent: '#e84545', bg: '#fff0f0', Icon: VerifiedIcon },
};

const DEFAULT = { accent: '#e84545', bg: '#fff0f0', Icon: AccountBalanceWalletIcon };

export default function ActionAreaCard({ loanType, handleLoanTypeForm, onClick, subtitle }) {
  const { accent, bg, Icon } = LOAN_CONFIG[loanType] ?? DEFAULT;
  const handleClick = onClick ?? (() => handleLoanTypeForm(loanType));
  const label = subtitle ?? 'Apply Now →';

  return (
    <Card
      onClick={handleClick}
      sx={{
        width: { xs: 150, sm: 190, md: 215, lg: 240, xl: 270 },
        mb: 2,
        borderRadius: '16px',
        border: `1.5px solid ${accent}33`,
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        transition: 'transform 0.22s ease, box-shadow 0.22s ease',
        overflow: 'hidden',
        bgcolor: '#ffffff',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: `0 14px 30px ${accent}30`,
        },
      }}
    >
      <CardActionArea
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 0,
        }}
      >
        <Box sx={{ width: '100%', height: '4px', flexShrink: 0 }} />

        <Box sx={{ pt: 3, pb: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            sx={{
              width: { xs: 70, xl: 84 },
              height: { xs: 70, xl: 84 },
              borderRadius: '50%',
              bgcolor: bg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <Icon sx={{ fontSize: { xs: 36, xl: 42 }, color: accent }} />
          </Box>

          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: { xs: '13px', sm: '14px', md: '15px' },
              color: '#1a1a2e',
              textAlign: 'center',
              lineHeight: 1.3,
              px: 1,
            }}
          >
            {loanType}
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: '11px',
              color: accent,
              mt: 0.75,
              mb: 2,
              fontWeight: 600,
              letterSpacing: '0.3px',
            }}
          >
            {label}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
}
